<template>
  <sh-gmail-card content-path="/gmail-intro.html"/>
</template>

<script>
    import GmailCard from "../../components/common/GmailCard"
    export default {
        name : "App",
        props : {
            content_path : String,
        },
        components : {
            "sh-gmail-card" : GmailCard
        },
    }
</script>

<style lang="sass">
  @import "../../styles/style"
</style>
